import { useState } from "react";
import {
  Input,
  FormLabel,
  FormControl,
  InputRightElement,
  InputGroup,
  Image,
  Text,
} from "@chakra-ui/react";

const FormikInput = ({
  formik,
  label,
  name = "",
  placeholder,
  isPassword,
  type,
  labelColor,
  labelSize,
  icon,
  disabled = false,
  unit,
  onChange,
}) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const inputType = type
    ? type
    : !isPassword
    ? "text"
    : isPasswordShown
    ? "text"
    : "password";

  return (
    <FormControl>
      <FormLabel
        color={labelColor ? labelColor : "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize ? labelSize : 12}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          name={name}
          value={formik && formik.values[name]}
          onChange={(e) => {
            formik.handleChange(e);
            formik.setFieldTouched(name, true, false); //  ensures touched is set while typing
          }}
          type={inputType}
          placeholder={placeholder}
          bg={"transparent"}
          fontFamily={"PlusJakartaSansRegular"}
          borderRadius={"4px"}
          fontSize={"12px"}
          lineHeight={"20"}
          color={"#000000"}
          _placeholder={{ color: "#898989" }}
          isDisabled={disabled}
          pr={unit || isPassword || icon ? "3rem" : "1rem"} // Add space for right element
        />
        {(unit || icon || isPassword) && (
          <InputRightElement height="100%" pointerEvents="none">
            <Text
              color="#898989"
              fontSize="12px"
              lineHeight="20px"
              fontFamily={"PlusJakartaSansRegular"}
              mr="8px"
            >
              {unit}
            </Text>
          </InputRightElement>
        )}
        {icon && <InputRightElement>{icon}</InputRightElement>}
        {isPassword && (
          <InputRightElement
            onClick={() => setIsPasswordShown((p) => !p)}
            height={"48px"}
          >
            {isPasswordShown ? (
              <Image src={require("assets/svgs/eye-crossed.svg").default} />
            ) : (
              <Image src={require("assets/svgs/eye.svg").default} />
            )}
          </InputRightElement>
        )}
      </InputGroup>
      {formik && formik.touched[name] && formik.errors[name] ? (
        <Text
          color="#FF0000"
          fontSize="12px"
          fontFamily={"PlusJakartaSansRegular"}
          lineHeight={"20px"}
          mt={1}
        >
          {formik.errors[name]}
        </Text>
      ) : null}
    </FormControl>
  );
};

export default FormikInput;
